import React from 'react';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import SettingsDescription from '@dashboard/components/SettingsDescription';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import Link from '@dashboard/components/Link/Link';

const SettingsCheckoutAbandonment = () => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();

  return (
    <SettingsContainer size="xl">
      <SettingsHeader id="checkout-abandonment">Checkout abandonment</SettingsHeader>
      <SettingsDescription className="mb-6">
        When a customer leaves without finishing checkout, we create a draft order. You can choose to
        save their email and send reminders to complete the order. You can also send saved emails to
        other apps with Zapier.{' '}
        <Link
          href="/help/articles/checkout-abandonment"
          color="default"
          blank
        >
          Learn more
        </Link>
      </SettingsDescription>

      <div className="my-4 max-w-lg">
        <Form
          enableReinitialize
          initialValues={{
            checkoutAbandonment: seller.checkoutAbandonment && {
              ...seller.checkoutAbandonment,
              showRecovered: seller.checkoutAbandonment.showRecovered !== false, // Default to true
            } || {
              collectEmails: false,
              sendEmails: false,
              showRecovered: true,
            },
          }}
          fields={({ values, setFieldValue }) => [
            {
              name: 'checkoutAbandonment.collectEmails',
              required: false,
              type: 'checkbox',
              label: 'Save emails from abandoned checkouts',
              tooltip: 'Store the customer\'s email when they leave without finishing checkout. Check local regulations before enabling.',
              onChange: (e) => {
                const isChecked = e.target.checked;
                setFieldValue('checkoutAbandonment.collectEmails', isChecked);
                // Auto-uncheck sendEmails when collectEmails is unchecked
                if (!isChecked) {
                  setFieldValue('checkoutAbandonment.sendEmails', false);
                }
              },
            },
            {
              name: 'checkoutAbandonment.sendEmails',
              required: false,
              type: 'checkbox',
              label: 'Send email reminders',
              tooltip: 'Automatically email customers a link to complete their order.',
              disabled: !values.checkoutAbandonment?.collectEmails,
              inset: true,
              className: !values.checkoutAbandonment?.collectEmails ? 'opacity-50 cursor-not-allowed' : '',
            },
            {
              name: 'checkoutAbandonment.showRecovered',
              required: false,
              type: 'checkbox',
              label: 'Show recovered revenue',
              tooltip: 'Display the amount of revenue recovered from abandoned checkouts.',
            },
          ]}
          onSubmit={async values => {
            try {
              const { data } = await updateSeller(values);

              return {
                data,
              };
            } catch (error) {
              return {
                error,
              };
            }
          }}
        />
      </div>
    </SettingsContainer>
  );
};

export default SettingsCheckoutAbandonment;